import React, { useState, useEffect } from 'react';
import { CustomerServiceOutlined, CloseOutlined, SendOutlined } from '@ant-design/icons';
import axios from 'axios';

const API = 'https://limitverify.ru:5000';
const SUPPORT_EMAIL = 'info@limitverify.ru';

const SupportButton = () => {
  const [botUsername, setBotUsername] = useState(null);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState('menu'); // menu | email | success
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ name: '', email: '', message: '' });

  useEffect(() => {
    const fetchBotUsername = async () => {
      try {
        const response = await axios.get(`${API}/api/public/telegram-bot-username`);
        if (response.data.success && response.data.botUsername) {
          setBotUsername(response.data.botUsername);
        }
      } catch (err) {
        console.error('Ошибка получения username бота техподдержки:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchBotUsername();
  }, []);

  const getClientContext = () => {
    const clientToken = localStorage.getItem('clientToken');
    const clientData = localStorage.getItem('clientData');
    if (!clientToken || !clientData) return null;
    try {
      return JSON.parse(clientData);
    } catch {
      return null;
    }
  };

  const openPanel = () => {
    const client = getClientContext();
    setError('');
    setMode('menu');
    setForm({
      name: client?.full_name || `${client?.first_name || ''} ${client?.last_name || ''}`.trim() || '',
      email: client?.email || '',
      message: ''
    });
    setOpen(true);
  };

  const closePanel = () => {
    setOpen(false);
    setMode('menu');
    setError('');
    setSending(false);
  };

  const openTelegram = () => {
    if (!botUsername) return;
    let telegramUrl = `https://t.me/${botUsername}`;
    const client = getClientContext();
    if (client?.id) {
      telegramUrl += `?start=client_${client.id}`;
    }
    window.open(telegramUrl, '_blank', 'noopener,noreferrer');
    closePanel();
  };

  const submitEmail = async (e) => {
    e.preventDefault();
    setError('');
    setSending(true);
    try {
      const client = getClientContext();
      const response = await axios.post(`${API}/api/public/support`, {
        name: form.name.trim(),
        email: form.email.trim(),
        message: form.message.trim(),
        clientId: client?.id || null
      });
      if (response.data.success) {
        setMode('success');
      } else {
        setError(response.data.error || 'Не удалось отправить сообщение');
      }
    } catch (err) {
      setError(
        err.response?.data?.error ||
          'Не удалось отправить сообщение. Напишите напрямую на info@limitverify.ru'
      );
    } finally {
      setSending(false);
    }
  };

  if (loading) return null;

  return (
    <>
      <button
        type="button"
        onClick={openPanel}
        title="Техподдержка"
        aria-label="Открыть техподдержку"
        style={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          width: 64,
          height: 64,
          borderRadius: '50%',
          background: '#1a472a',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          boxShadow: '0 4px 16px rgba(26, 71, 42, 0.4)',
          transition: 'all 0.3s ease',
          zIndex: 1000,
          border: 'none',
          padding: 0
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#2d5a3d';
          e.currentTarget.style.transform = 'scale(1.08)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = '#1a472a';
          e.currentTarget.style.transform = 'scale(1)';
        }}
      >
        <CustomerServiceOutlined style={{ fontSize: 32, color: '#fff' }} />
      </button>

      {open && (
        <div
          onClick={closePanel}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.55)',
            zIndex: 1001,
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
            padding: 24
          }}
        >
          <div
            className="lm-modal"
            onClick={(e) => e.stopPropagation()}
            style={{
              width: 'min(420px, 100%)',
              margin: 0,
              position: 'relative',
              maxHeight: '85vh',
              overflow: 'auto'
            }}
          >
            <button
              type="button"
              className="lm-modal__close"
              onClick={closePanel}
              aria-label="Закрыть"
            >
              <CloseOutlined />
            </button>

            {mode === 'menu' && (
              <>
                <h3 className="lm-modal__title">Техподдержка</h3>
                <p className="lm-text-3 lm-muted" style={{ margin: '0 0 16px' }}>
                  Выберите удобный способ связи. Если Telegram недоступен — напишите на почту.
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {botUsername && (
                    <button type="button" className="lm-btn lm-btn--block" onClick={openTelegram}>
                      Написать в Telegram
                    </button>
                  )}
                  <button
                    type="button"
                    className="lm-btn lm-btn--block"
                    onClick={() => setMode('email')}
                  >
                    Написать на почту
                  </button>
                  <a
                    className="lm-link lm-link--accent"
                    href={`mailto:${SUPPORT_EMAIL}`}
                    style={{ textAlign: 'center', marginTop: 4 }}
                  >
                    {SUPPORT_EMAIL}
                  </a>
                </div>
              </>
            )}

            {mode === 'email' && (
              <>
                <h3 className="lm-modal__title">Сообщение в поддержку</h3>
                <p className="lm-text-3 lm-muted" style={{ margin: '0 0 16px' }}>
                  Письмо уйдёт на {SUPPORT_EMAIL}. Мы ответим на ваш email.
                </p>
                <form onSubmit={submitEmail} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                  <label className="lm-field">
                    <span className="lm-field__label">Имя</span>
                    <input
                      className="lm-field__input"
                      value={form.name}
                      onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
                      required
                      minLength={2}
                      placeholder="Как к вам обращаться"
                    />
                  </label>
                  <label className="lm-field">
                    <span className="lm-field__label">Email для ответа</span>
                    <input
                      className="lm-field__input"
                      type="email"
                      value={form.email}
                      onChange={(e) => setForm((p) => ({ ...p, email: e.target.value }))}
                      required
                      placeholder="you@example.com"
                    />
                  </label>
                  <label className="lm-field">
                    <span className="lm-field__label">Сообщение</span>
                    <textarea
                      className="lm-field__input"
                      value={form.message}
                      onChange={(e) => setForm((p) => ({ ...p, message: e.target.value }))}
                      required
                      minLength={5}
                      rows={5}
                      placeholder="Опишите вопрос"
                      style={{ height: 'auto', resize: 'vertical', paddingTop: 10, paddingBottom: 10 }}
                    />
                  </label>

                  {error && (
                    <div className="lm-text-3 lm-danger" style={{ margin: 0 }}>
                      {error}
                    </div>
                  )}

                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    <button
                      type="button"
                      className="lm-btn"
                      onClick={() => {
                        setMode('menu');
                        setError('');
                      }}
                      disabled={sending}
                    >
                      Назад
                    </button>
                    <button type="submit" className="lm-btn" disabled={sending} style={{ flex: 1 }}>
                      <SendOutlined style={{ marginRight: 8 }} />
                      {sending ? 'Отправка...' : 'Отправить'}
                    </button>
                  </div>
                </form>
              </>
            )}

            {mode === 'success' && (
              <>
                <h3 className="lm-modal__title">Сообщение отправлено</h3>
                <p className="lm-text-3" style={{ margin: '0 0 16px', color: 'var(--text-primary)' }}>
                  Мы получили ваше обращение и ответим на указанный email.
                </p>
                <button type="button" className="lm-btn lm-btn--block" onClick={closePanel}>
                  Закрыть
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default SupportButton;
